export default __webpack_public_path__ + "resources/icons/n211-5cc7.png";